import { render } from "./selectOption.vue?vue&type=template&id=0a3eca0a&scoped=true"
import script from "./selectOption.vue?vue&type=script&lang=js"
export * from "./selectOption.vue?vue&type=script&lang=js"

import "./selectOption.vue?vue&type=style&index=0&id=0a3eca0a&lang=scss&scoped=true"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3eca0a"]])

export default __exports__